import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromAnyObject from '../reducers/any-object.reducer';
import * as fromCommonObjectList from '../reducers/common-object-list-uniqueId.reducer';

@Injectable()
export class SelectorGeneratorService {
	private selectors: any = {};
	private state: any;

	

	public getSelectors(config: any, featureName: string): any {
		const thisState = createFeatureSelector<any>(featureName);
		if (config) {
			const keys = Object.keys(config);
			if (keys && keys.length) {
				const selectors = {};
				keys.forEach(key => {
					const each = config[key];
					if (each.storeAsList) {
						selectors[each.name] = createSelector(createSelector(thisState, state => state[each.name]), fromCommonObjectList.getCommonObjectList);
					} else {
						selectors[each.name] = createSelector(createSelector(thisState, state => state[each.name]), fromAnyObject.getObject);
					}
				});
				return selectors;
			}
		}
	}

	public getSelector(config: any, featureName: string): any {
		if (config.name) {
			const currentSelector = this.selectors && this.selectors[config.name];
			if (!currentSelector && featureName) {
				return this.createSelector(config.name, config.storeAsList, featureName);
			} else {
				return this.selectors[config.name];
			}
		}
	}

	public createSelector(name: any, storeAsList: boolean, featureName: string): any {
		const thisState = createFeatureSelector<any>(featureName);
		if (storeAsList) {
			this.selectors[name] = createSelector(createSelector(thisState, state => state[name]), fromCommonObjectList.getCommonObjectList);
		} else {
			this.selectors[name] = createSelector(createSelector(thisState, state => state[name]), fromAnyObject.getObject);
		}
		return this.selectors[name];
	}
}
